module.exports = __webpack_public_path__ + "img/logo.ac8c32d4.png";